module.exports = "<!--<div id=\"chatdiv\" style=\"display:none\">\n        This is my DIV element.\n        </div>\n        <button onclick=\"myFunction()\">Try it</button>\n Start People Module Bottom Add Button -->\n<div class=\"cat__footer fab_menu\">\n</div>\n<!-- End Task Module Bottom Add Widget Button -->"


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/components/footer/footer.component.html
// module id = ../../../../../src/app/common/components/footer/footer.component.html
// module chunks = main